/* eslint-disable max-lines-per-function */ /* eslint-disable max-params */ /* eslint-disable @typescript-eslint/no-explicit-any */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ApiProvider: ()=>ApiProvider,
    useApi: ()=>useApi,
    useApiGet: ()=>useApiGet,
    useApiPost: ()=>useApiPost,
    useApiPut: ()=>useApiPut,
    useApiPatch: ()=>useApiPatch,
    useApiDelete: ()=>useApiDelete
});
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const ApiContext = /*#__PURE__*/ _react.default.createContext({});
const ApiProvider = ({ api , children  })=>{
    const [isLoading, setLoading] = (0, _react.useState)(false);
    const makeGet = (0, _react.useCallback)(async (...args)=>{
        try {
            setLoading(true);
            const data = await api.get(...args);
            setLoading(false);
            return data;
        } catch (_error) {
            const error = _error;
            setLoading(false);
            return {
                error
            };
        }
    }, [
        api,
        setLoading
    ]);
    const makePost = (0, _react.useCallback)(async (...args)=>{
        try {
            setLoading(true);
            const data = await api.post(...args);
            setLoading(false);
            return data;
        } catch (_error) {
            const error = _error;
            setLoading(false);
            return {
                error
            };
        }
    }, [
        api,
        setLoading
    ]);
    const makePut = (0, _react.useCallback)(async (...args)=>{
        try {
            setLoading(true);
            const data = await api.put(...args);
            setLoading(false);
            return data;
        } catch (_error) {
            const error = _error;
            setLoading(false);
            return {
                error
            };
        }
    }, [
        api,
        setLoading
    ]);
    const makePatch = (0, _react.useCallback)(async (...args)=>{
        try {
            setLoading(true);
            const data = await api.patch(...args);
            setLoading(false);
            return data;
        } catch (_error) {
            const error = _error;
            setLoading(false);
            return {
                error
            };
        }
    }, [
        api,
        setLoading
    ]);
    const makeDelete = (0, _react.useCallback)(async (...args)=>{
        try {
            setLoading(true);
            const data = await api.delete(...args);
            setLoading(false);
            return data;
        } catch (_error) {
            const error = _error;
            setLoading(false);
            return {
                error
            };
        }
    }, [
        api,
        setLoading
    ]);
    const context = {
        isLoading,
        get: makeGet,
        post: makePost,
        put: makePut,
        patch: makePatch,
        delete: makeDelete,
        setHeaders: (0, _react.useCallback)((...args)=>api.setHeaders(...args), [
            api
        ]),
        unsetHeaders: (0, _react.useCallback)((...args)=>api.unsetHeaders(...args), [
            api
        ]),
        headerIsSet: (0, _react.useCallback)((...args)=>api.headerIsSet(...args), [
            api
        ]),
        setStore: (0, _react.useCallback)((...args)=>api.setStore(...args), [
            api
        ]),
        resetStore: (0, _react.useCallback)((...args)=>api.resetStore(...args), [
            api
        ])
    };
    return /*#__PURE__*/ _react.default.createElement(ApiContext.Provider, {
        value: context
    }, children);
};
const useApi = ()=>_react.default.useContext(ApiContext);
// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = ()=>{};
const useApiGet = (path, options, callback = noop)=>{
    const { isLoading , get  } = useApi();
    (0, _react.useEffect)(()=>{
        get(path, options || {}).then((data)=>callback && callback(null, data)).catch((res)=>callback && callback(res.error, null));
    }, [
        get
    ]);
    return {
        isLoading
    };
};
const useApiPost = (path, payload, options, callback = noop)=>{
    const { isLoading , post  } = useApi();
    (0, _react.useEffect)(()=>{
        post(path, payload, options || {}).then((data)=>callback && callback(null, data)).catch((res)=>callback && callback(res.error, null));
    }, [
        post
    ]);
    return {
        isLoading
    };
};
const useApiPut = (path, payload, options, callback = noop)=>{
    const { isLoading , put  } = useApi();
    (0, _react.useEffect)(()=>{
        put(path, payload, options || {}).then((data)=>callback && callback(null, data)).catch((res)=>callback && callback(res.error, null));
    }, [
        put
    ]);
    return {
        isLoading
    };
};
const useApiPatch = (path, payload, options, callback = noop)=>{
    const { isLoading , patch  } = useApi();
    (0, _react.useEffect)(()=>{
        patch(path, payload, options || {}).then((data)=>callback && callback(null, data)).catch((res)=>callback && callback(res.error, null));
    }, [
        patch
    ]);
    return {
        isLoading
    };
};
const useApiDelete = (path, options, callback = noop)=>{
    const { isLoading , delete: del  } = useApi();
    (0, _react.useEffect)(()=>{
        del(path, options || {}).then((data)=>callback && callback(null, data)).catch((res)=>callback && callback(res.error, null));
    }, [
        del
    ]);
    return {
        isLoading
    };
};
